import React, { useEffect } from "react";
import { LoadingProgressBar } from "@components";
import { useLogout } from "@hooks";

export const LogoutWithRedirect = () => {
  const { logout } = useLogout();

  useEffect(() => {
    void logout();
  }, [logout]);

  return <LoadingProgressBar />;
};
